var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isQueryApplicable = function isQueryApplicable(queryString) {
    if (!queryString) {
        return false;
    }
    // ensure query contains more than 2 characters ONLY when it represents non-numeric value
    return isNaN(queryString) ? queryString.length > 2 : true;
};

var TableFilterCtrl = function () {
    function TableFilterCtrl($filter) {
        _classCallCheck(this, TableFilterCtrl);

        this.queryString = null;
        this.$filter = $filter;
    }

    _createClass(TableFilterCtrl, [{
        key: 'predicate',
        value: function predicate(value, queryString) {
            var normalizePhrase = function normalizePhrase(phrase) {
                return phrase ? phrase.toLowerCase() : '';
            };

            var normalizedQuery = normalizePhrase(queryString);
            return this.filterableProperties.some(function (property) {
                return normalizePhrase(value[property]).includes(normalizedQuery);
            });
        }
    }, {
        key: 'makeQuery',
        value: function makeQuery() {
            var _this = this;

            var dataSource = this.data && Array.isArray(this.data) ? this.data : [];
            var isApplicable = isQueryApplicable(this.queryString);
            var queriedData = isApplicable ? this.$filter('filter')(dataSource, function (value) {
                return _this.predicate(value, _this.queryString);
            }) : dataSource;

            this.onQuery(queriedData, isApplicable, this.queryString);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var data = _ref.data;

            if (data && data.currentValue) {
                this.makeQuery();
            }
        }
    }]);

    return TableFilterCtrl;
}();

TableFilterCtrl.$inject = ['$filter'];
export default TableFilterCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/table/TableFilter/TableFilterCtrl.js
// module id = 1151
// module chunks = 0